
import { defineComponent } from "vue";
import { mapActions, mapGetters } from "vuex";
import * as fb from "../../firebase";
import * as bs from "bootstrap";

export default defineComponent({
  name: "virtual-classroom",
  data() {
    return {
      gettingToken: false,
    };
  },
  props: {
    showLiveClasses: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters("auth", ["getUsernamePK"]),
    ...mapGetters("profile", { moodleData: "getUserMoodleData" }),
    isClassroomActive(): boolean {
      return this.moodleData ? this.moodleData.status === "active" : false;
    },
  },
  methods: {
    ...mapActions("profile", ["doGetUserMoodleData"]),
    classroomLogin() {
      this.gettingToken = true;
      const classroomInfoRequest = {
        username: this.getUsernamePK,
        returnto: "/",
      };

      const GetMoodleToken = fb.func.httpsCallable("Moodle-MoodleSsoStart");
      GetMoodleToken(classroomInfoRequest)
        .then((response) => {
          const info = response.data;
          if (info.OPCODE == "SUCCESS") {
            (this.$refs.formClassroom as HTMLFormElement).action =
              info.data.moodleRedirect;
            (this.$refs.btnSubmit as HTMLButtonElement).click();
          } else {
            alert(
              "No se pudo obtener la información para acceder a las clases grabadas."
            );
          }
        })
        .finally(() => {
          this.gettingToken = false;
        });
    },
  },
  mounted() {
    new bs.Popover(this.$refs.popups);
    new bs.Popover(this.$refs.activando);

    this.doGetUserMoodleData(this.getUsernamePK);
  },
});
